import { useAuthStore } from '@/store/auth.store';
import { Navigate, useLocation } from 'react-router-dom';
import { destinationApresConnexion } from './destination-apres-connexion';

interface PublicRouteProps {
  children: React.ReactNode;
}

export const PublicRoute = ({ children }: PublicRouteProps) => {
  const { isAuthenticated } = useAuthStore();
  const location = useLocation();

  if (isAuthenticated) {
    const from = destinationApresConnexion(
      location.search,
      location.state?.from?.pathname
    );
    return <Navigate to={from} replace />;
  }

  return <>{children}</>;
};
